/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { memo } from "react";

// CSS読み込み
import {
  mtgBody,
  mtgCaption,
  modalGroup,
  modalImg,
  modalLabel
} from "assets/css/stylesCss";

import {
  modalImgLineUp
} from "assets/css/shchMtmr";

// ガスコンロ全体写真
const ZentaiSmall = require("assets/img/modalImages/modalHowToShootGasStove/zentai/kyutouki-@1x.jpg");
const ZentaiMedium = require("assets/img/modalImages/modalHowToShootGasStove/zentai/kyutouki-@2x.jpg");
const ZentaiLarge = require("assets/img/modalImages/modalHowToShootGasStove/zentai/kyutouki-@3x.jpg");

// コンロ下部
const KabuSmall = require("assets/img/modalImages/modalHowToShootGasStove/kabu/conro-@1x.jpg");
const KabuMedium = require("assets/img/modalImages/modalHowToShootGasStove/kabu/conro-@2x.jpg");
const KabuLarge = require("assets/img/modalImages/modalHowToShootGasStove/kabu/conro-@3x.jpg");

// コンロ型番
const KatabanSmall = require("assets/img/modalImages/modalHowToShootGasStove/kataban/kataban-@1x.jpg");
const KatabanMedium = require("assets/img/modalImages/modalHowToShootGasStove/kataban/kataban-@2x.jpg");
const KatabanLarge = require("assets/img/modalImages/modalHowToShootGasStove/kataban/kataban-@3x.jpg");

// コンロ型番位置（左）
const KatabanPositionLeftSmall = require("assets/img/modalImages/modalHowToShootGasStove/katabanPositionLeft/katabanPositionLeft-@1x.png");
const KatabanPositionLeftMedium = require("assets/img/modalImages/modalHowToShootGasStove/katabanPositionLeft/katabanPositionLeft-@2x.png");
const KatabanPositionLeftLarge = require("assets/img/modalImages/modalHowToShootGasStove/katabanPositionLeft/katabanPositionLeft-@3x.png");

// コンロ型番位置（右）
const KatabanPositionRightSmall = require("assets/img/modalImages/modalHowToShootGasStove/katabanPositionRight/katabanPositionRight-@1x.png");
const KatabanPositionRightMedium = require("assets/img/modalImages/modalHowToShootGasStove/katabanPositionRight/katabanPositionRight-@2x.png");
const KatabanPositionRightLarge = require("assets/img/modalImages/modalHowToShootGasStove/katabanPositionRight/katabanPositionRight-@3x.png");

/**
 * 「ガスコンロの撮り方」モーダル画面
 */
const ModalHowToShootGasStove = memo(() => {
  return (
    <>
      <h2>ガスコンロの撮り方</h2>
      <section css={modalGroup}>
        <p css={mtgBody}>
          代表的な機器の参考写真をご確認ください。ガス機器の型番が判明すると見積もりご依頼後のスムーズな対応が可能です。
        </p>
      </section>
      <section css={modalGroup}>
        <div css={modalGroup}>
          <label css={modalLabel}>コンロ全体写真</label>
          <p css={mtgCaption}>
            天板部分と正面が両方映るように撮影してください。
          </p>
          <img
            css={modalImg}
            src={ZentaiSmall}
            srcSet={`${ZentaiSmall} 1x, ${ZentaiMedium} 2x, ${ZentaiLarge} 3x`}
            alt="全体写真"
          />
        </div>
      </section>
      <section css={modalGroup}>
        <div css={modalGroup}>
          <label css={modalLabel}>コンロ下部</label>
          <p css={mtgCaption}>
            ガス配管全体・コンロとの接続位置が確認できるようにキャビネット内を撮影してください。
          </p>
          <img
            css={modalImg}
            src={KabuSmall}
            srcSet={`${KabuSmall} 1x, ${KabuMedium} 2x, ${KabuLarge} 3x`}
            alt="コンロ下部"
          />
        </div>
      </section>
      <section css={modalGroup}>
        <div css={modalGroup}>
          <label css={modalLabel}>コンロ型番</label>
          <p css={mtgCaption}>
            型番がわかるよう、ステッカー全体を撮影してください。
          </p>
          <img
            css={modalImg}
            src={KatabanSmall}
            srcSet={`${KatabanSmall} 1x, ${KatabanMedium} 2x, ${KatabanLarge} 3x`}
            alt="コンロ型番"
          />
        </div>
      </section>
      <section css={modalGroup}>
        <div css={modalGroup}>
          <label css={modalLabel}>コンロ型番位置</label>
          <p css={mtgCaption}>
            下記図のように電池ケースのフタの裏側に印字されています。<br />
            ※コンロ操作パネルの裏側に印字されている場合もあります。
          </p>
          <div css={modalImgLineUp}>
            <img
              css={modalImg}
              src={KatabanPositionLeftSmall}
              srcSet={`${KatabanPositionLeftSmall} 1x, ${KatabanPositionLeftMedium} 2x, ${KatabanPositionLeftLarge} 3x`}
              alt="コンロ下部"
            />
            <img
              css={modalImg}
              src={KatabanPositionRightSmall}
              srcSet={`${KatabanPositionRightSmall} 1x, ${KatabanPositionRightMedium} 2x, ${KatabanPositionRightLarge} 3x`}
              alt="コンロ下部"
            />
          </div>
        </div>
      </section>
    </>
  );
});

export default ModalHowToShootGasStove;
